import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Redirect } from 'react-router-dom';
import { Query } from 'react-apollo';

import ProjectList from './ProjectList';
import Loading from '../../Loading';
import ErrorMessage from '../../Error';
import { GET_PROJECTS } from './projects.gql';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  }
}));

export default function Projects() {
  const classes = useStyles();
  const [selectedCentral, setSelectedCentral] = React.useState(-1);
  const onCentralSelected = (centralID) => {
    setSelectedCentral(centralID);
  };

  return (
    <div className={classes.root}>
      {selectedCentral === -1
        ? (
          <Query query={GET_PROJECTS}>
            {({ data, error, loading }) => {
              if (loading) {
                return <Loading />;
              }

              if (error) {
                return <ErrorMessage error={error} />;
              }

              if (data !== undefined) {
                return <ProjectList source={data} onCentralSelected={onCentralSelected} />;
              }

              return null;
            }}
          </Query>
        )
        : <Redirect to={`/central/${selectedCentral}`} />
      }
    </div>
  );
}
